angular.module('autoremind.dashboard.filters', [])
    .filter('visibleWidgets', [function () {
        return function (widgets, isVisible) {
            for (var i in widgets) {
                if (isVisible === widgets[i].visible) {
                    return true;
                }
            }
            return false;
        };
    }]);
//# sourceMappingURL=dashboard.filters.js.map